import { ArrowUp } from 'lucide-react'
import React from 'react'
import { useSelector } from 'react-redux'
import { isRtlSelector } from 'redux/selectors/general'
import useLocaleText from 'components/useLocaleText'
import { Button } from '../Button'

interface Props {
  onSubmit: () => void
  is_numeric?: boolean
}

export const TextAreaSubmitBtn: React.FC<Props> = ({ onSubmit, is_numeric = false }) => {
  const isRtl = useSelector(isRtlSelector)
  const submitLabel = useLocaleText({ send: { key: 'send', fallback: { en: 'Send', he: 'שליחה' } } })

  return (
    <Button
      type="button"
      aria-label={submitLabel.send}
      onMouseDown={(event) => event.preventDefault()}
      onClick={onSubmit}
      pos="absolute"
      bottom={is_numeric ? '7px' : '15px'}
      right={isRtl ? 'unset' : '10px'}
      left={isRtl ? '10px' : 'unset'}
      borderRadius="full"
      bg="black"
      w="30px"
      h="30px"
      minW="30px"
      p={0}
      boxShadow="0px 0px 2px 1px white"
      _hover={{ bg: 'black', transform: 'scale(1.1)' }}
    >
      <ArrowUp color="white" size={16} strokeWidth={4} />
    </Button>
  )
}
